import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSkeletonBox = (props) => {
  const { height = '70vh' } = props;
  return (
    <div 
      className="container skeleton-box"
      style={{ 
        padding: '100px 20px 20px 20px', 
        minHeight: height, 
        background: '#f6f9ff', 
        textAlign: 'center' 
      }}
    >
      <Spinner animation="grow" style={{width: '20px', height: '20px', color: '#b8caed' }} />
      <Spinner animation="grow" style={{width: '20px', height: '20px', color: '#c4d2ee', animationDelay: '0.2s' }} />
      <Spinner animation="grow" style={{width: '20px', height: '20px', color: '#b8caed', animationDelay: '0.4s' }} />
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export default LoadingSkeletonBox;
